<template>
  <div id="divNotifications" class="col-lg-12 custom-margin-top">
    
    <!-- Medically Fragile Option -->
    <div id="divMedicallyFragileOption" v-if="medicallyFragileSettings.isEnabled">
      <div class="row">
        <div class="col-lg-12">
          <h4>{{medicallyFragileSettings.headerText}}</h4>
          <hr />
        </div>
      </div>
          
      <div class="row margin-top-15 margin-bottom-25">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p id="medFragOptionDescription">{{medicallyFragileSettings.description}}</p>
          <button id="btnMedFragOption" class="btn" aria-label="Medically Fragile Send Message" :disabled="!medicallyFragileSettings.isButtonEnabled" @click.prevent="openModal(medicallyFragileSettings, 6)">{{medicallyFragileSettings.btnText}}</button>
        </div>
      </div>    

      <hr style="margin-bottom: 15px !important;" />
    </div>

    <div class="row">
      <div class="col-lg-12">
        <!-- ------------------------------------- -->
        <!-- Begin: Send Barcode -->
        <!-- ------------------------------------- -->
        <div id="divSendBarcodeOuter" :class="dailyAlertDetails !== '' && dailyAlertDetails.Enabled ? 'col-lg-6' : 'col-lg-12'" v-if="barcodeDetails !== ''">          
          <div id="divSendBarcode">
            <div class="row">
              <div class="col-lg-12">
                <h4>{{ $t("message.sendBarcode") }}</h4>
                <hr />
              </div>
            </div>                  
            <div class="row margin-top-15 margin-bottom-25">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <p id="barcodeMessage" v-html="barcodeDetails.Message"></p>
                <button id="btnSendBarcode" class="btn" aria-label="Send Barcode" :disabled="barcodeDetails.Disabled || disableEditOrDelete" @click.prevent="sendPaymentBarcode()">{{ $t("message.sendBarcode") }}</button>
              </div>
            </div>    
            <hr style="margin-bottom: 15px !important;" />
          </div>          
        </div>
        <!-- ------------------------------------- -->
        <!-- End: Send Barcode -->
        <!-- ------------------------------------- -->
        

        <!-- ------------------------------------- -->
        <!--Start: Daily Usage Alert-->
        <!-- ------------------------------------- -->
        <div id="divUsageAlertOuter" class="col-lg-6" v-if="dailyAlertDetails !== '' && dailyAlertDetails.Enabled">
          <div id="divDailyUsageAlert">
            <div class="row">
              <div class="col-lg-12">
                <h4>{{ $t("message.dailyUsageAlert") }}</h4>
                <hr/>
              </div>
            </div>          
            <div class="row margin-top-15 margin-bottom-25">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <p id="dailyAlertMessage" v-html="dailyAlertDetails.Message"></p> 
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                $<input type="text" id="dailyAlertAmountInput" v-model="dailyAlertDetails.Amount" placeholder="Unenrolled" class="form-control dailyalert-amt margin-left-2" />
                <button id="btnSave" class="btn btn-primary" @click.prevent="saveDailyUsage(true)" :disabled="dailyAlertDetails.Amount === null || dailyAlertDetails.Amount === '' || dailyAlertDetails.Amount === previousDailyAlertAmount" aria-label="Save">{{ $t("message.save") }}</button>
                <button id="btnUnenroll" class="btn btn-primary" @click.prevent="saveDailyUsage(false)" :disabled="previousDailyAlertAmount === null" aria-label="Unenroll">{{ $t("message.unenroll") }}</button>
              </div>
            </div>
            <hr style="margin-bottom: 15px !important;" />
          </div>          
        </div>
        <!-- ------------------------------------- -->
        <!--End: Daily Usage Alert--> 
        <!-- ------------------------------------- -->  
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h4>{{ $t("message.notificationContact") }}</h4>
        <hr />
      </div>
    </div>    

    <!--Start Notification Contacts-->
    <div class="row custom-margin-top">
      <div class="col-lg-12 col-flex-wrap">
        <div class="col-md-6 col-xs-12 contact-div custom-margin-top" v-for="(contactType, index) in notificationTypes" :key="index">
          <!--Header-->
          <div class="row list-group-item pad5">
            <div class="col-md-6 col-xs-5">
              <b>{{contactType.Name}} ({{ $t("message.limit") }}{{contactType.Limit}})</b>
            </div>
            <div class="col-md-2 col-xs-4 text-center">
              <b>{{ $t("message.active") }}</b>
            </div>
            <div class="col-md-4 col-xs-3 text-right">
              <button class="btn btn-primary btn-xs pull-right" @click.prevent="openModal(contactType, 1)" :disabled="contactType.AddNewDisabled" aria-label="Add New Contact">{{ $t("message.addNew") }}</button>
            </div>
          </div>
          <!--End Header-->

          <!--No Data-->
          <div class="row list-group-item pad5" v-if="contactType.Contacts.length === 0">
            <div class="col-md-6 col-xs-5">
              {{ $t("message.noContactsAvailable") }}
            </div>
          </div>
          <!--End No Data-->

          <!--Row Data-->
          <div class="row list-group-item pad5" v-for="(contact, index) in contactType.Contacts" :key="index">
            <div class="col-md-6 col-xs-5 col-word-break">
              <label for="chk{{index}}">{{contact.Value}}</label>
              <!--ContactType.ID 1 is Emails, where this image will not show-->
              <img :src="getImageSrc(contact.MsgOptIn, contactType.ID)" :title="getImageTitle(contact.MsgOptIn)" v-if="contactType.ID !== 3" alt="Contact Status Icon" />
            </div>
            <div class="col-md-2 col-xs-4 text-center">
              <button class="btn btn-xs btn-primary" @click="sendCode(contact.ID, 2)" v-if="contact.ShowVerifyButton" aria-label="Verify Code" :disabled="disableEditOrDelete">{{ $t("message.verify") }}</button>
              <input id="chk{{index}}" type="checkbox" @click="changeActive(contact.ID)" :checked="contact.IsActive" v-if="!contact.ShowVerifyButton" :disabled="contact.ActiveCheckboxDisabled || disableEditOrDelete" role="checkbox" />
            </div>
            <div class="col-md-4 col-xs-3 text-right div-btn-delete">
              <button class="btn btn-xs btn-danger pull-right" @click="openModal({'ID': contact.ID, 'typeID': contactType.ID, 'Value': contact.Value}, 3)"
                          :disabled="contact.DeleteDisabled" aria-label="Delete">{{ $t("message.delete") }}</button>
            </div>
          </div>
          <!--End Row Data-->
        </div>
      </div>
    </div>
    <!--End Notification Contacts-->
    <!--Start Time Periods-->
    <div class="row custom-margin-top">
      <div class="col-lg-12">
        <div class="col-md-6 col-xs-12">
          <h4>{{ $t("message.notificationWindow") }}</h4>
          <hr />
          <div class="row line25" v-for="(contactType, index) in notificationTypes" :key="index">
            <div class="col-md-9 col-xs-7">
              <span>{{contactType.Name}} {{getMessageWindow(contactType.WindowStartTime, contactType.WindowEndTime, contactType.ZoneID)}}</span>
            </div>
            <div class="col-md-3 text-right padnotif">
              <button class="btn btn-xs btn-primary pull-right btn-change" @click="openModal(contactType, 4)">{{ $t("message.change") }}</button>
            </div>
          </div>
        </div>
        <!--End Time Periods-->
        <!--Start Low Balance Notifications-->
        <div class="col-md-6 col-xs-12 notifications-lowbal">
          <h4>{{ $t("message.lowBalanceNotifications") }}</h4>
          <hr />

          <div class="row">
            <div class="col-md-12 col-xs-12">
              <p v-html="lowBalanceDaysDescriptionText" v-if="lowBalanceDaysDescriptionText.length > 0"></p>
              <h5 class="lowbalance-title" v-else>
                <strong>{{ $t("message.lowBalanceNotificationDaysSelected") }}</strong>
              </h5>
            </div>
          </div>

          <div class="row custom-margin-top">
            <div class="col-md-12 col-xs-12">
              <div v-for="(window, index) in notificationWindows" :key="index" class="div-inline-block divLowBalanceNotificationDays">
                <button type="button" :disabled="window.Required || disableEditOrDelete"
                        v-bind:class="window.DayActive ? 'btn btn-primary active btn-lowbal-selected' : 'btn btn-default'"
                        @click="updateNotice(window)">{{window.NumberofDays}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--End Low Balance Notifications-->
    <!--Start Billing Address-->
    <div class="row custom-margin-top" v-if="displayBillingAddress">
      <div class="col-lg-12">
        <div class="col-md-6">
          <h4>{{ $t("message.billingAddress") }}</h4>
          <hr />
          <div class="pad-top-10">
            {{address.Address1}}{{address.Address2 ? ' ' + address.Address2 + '\n' : ''}} {{address.City}}, {{address.State}} {{address.Zip}}<br /><br />
            <button class="btn btn-primary btn-xs" @click="openModal(address, 5)" v-show="isBillingAddressEditable" aria-label="Change Address">{{ $t("message.changeAddress") }}</button>
          </div>
        </div>
      </div>
    </div>
    <!--End Billing Address-->
    <!--Notification Pop-ups-->
    <!-- In all cases with popups, I assign the values to "popupdata".  I do this because two-way binding actually works against me
        in this instance... in the event you hit cancel, I don't want the values of the object to have automatically updated.  Only after you hit save do I do the update.-->
    <modal v-show="showModal === 1" @close="closeModal()">
      <h4 class="modal-title" slot="header">{{ $t("message.addContact") }}</h4>
      <div slot="body">
        <form @submit.prevent="saveContact()">
          <!-- Text Message Disclaimer -->
          <div id="divTextMessageDisclaimer" v-if="popupData.ID === this.$contactTypes.Text" class="padding-bottom-5">
            <p v-html="textMessageDisclaimer" class="disclaimer-text"></p>
          </div>   

          <div id="divCritical" v-if="popupData.ID === this.$contactTypes.Critical">
            <label class="controlLabel">{{ $t("message.notificationType") }}:</label>
            <br />
            <select v-model="contactTypeIdSelectedForCritical" class="dropdown form-control form-control-m">
              <option v-for="(option, index) in filteredContactTypes" v-bind:key="option.ID" :value="option.ID" v-bind:selected="index === 0">{{option.Name}}</option>
            </select>
          </div>

          <div class="custom-margin-top">
            <label class="controlLabel" >{{ getMessageType(popupData.ID) }}</label>
            <br />
            <!-- These may seem the same, and on a regular webform, it is. On phones though, type="tel" will make the phone number display appear -->
            <input type="tel" class="form-control" v-model="popupText" v-if="popupData.ID <= 2" ref="modalAddContactPhone" />
            <input type="text" class="form-control" v-model="popupText" v-if="popupData.ID > 2" ref="modalAddContactEmail" />
          </div>
        </form>
      </div>
      <p slot="footer">
        <span class="pull-right">
          <button class="btn btn-primary" @click="saveContact()" aria-label="Add Contact" :disabled="disableEditOrDelete">{{ $t("message.add") }}</button>
          &nbsp;
          <button class="btn btn-cancel" @click="closeModal()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
        </span>
      </p>
    </modal>
    <modal v-show="showModal === 2" @close="deleteContact()">
      <h4 class="modal-title" slot="header">{{ $t("message.optInToTexting") }}</h4>
      <div slot="body">
        <form @submit.prevent="verifyCode()">
          <div id="divVerifyCodeMessage">
            <span>{{ $t("message.optInCodeText") }}</span>
          </div>
          <div class="custom-margin-top">
            <label for="verifyCode" class="controlLabel">{{ $t("message.verificationCode") }}</label>
            <br />
            <input id="verifyCode" type="text" v-on:keypress="isNumber(event)" v-model="verifyCodeInput" class="form-control form-control-m" maxlength="10" v-focus="true" />
          </div>
        </form>
      </div>
      <p slot="footer">
        <span class="pull-right">
          <button class="btn btn-primary" @click="verifyCode()" aria-label="Verify Code">{{ $t("message.verifyCode") }}</button>&nbsp;
          <button class="btn btn-cancel" @click="deleteContact()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
        </span>
      </p>
    </modal>
    <modal v-show="showModal === 3" @close="closeModal()">
      <h4 class="modal-title" slot="header">{{ $t("message.deleteContact") }}</h4>
      <p slot="body">
        <label class="controlLabel" >
          {{ $t("message.deleteContactConfirmation") }} <b>{{popupData.Value}}</b>?
        </label>
      </p>
      <p slot="footer">
        <span class="pull-right">
          <button class="btn btn-primary btn-danger" @click="deleteContact()" aria-label="Delete" :disabled="disableEditOrDelete">{{ $t("message.delete") }}</button>
          &nbsp;
          <button class="btn btn-cancel" @click="closeModal()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
        </span>
      </p>
    </modal>
    <modal v-show="showModal === 4" @close="closeModal()">
      <h4 class="modal-title" slot="header">{{ $t("message.changeNotificationWindow") }}</h4>
      <div slot="body">
        <form @submit.prevent="saveWindow()">
          <fieldset>
            <div class="row">
              <div class="col-md-12">
                <input id="rdoAnytime" type="radio" value="true" v-model="popupData.ShowAnyTime" name="notificationwindow" />
                <label for="rdoAnytime">{{ $t("message.anytime") }}</label>
              </div>
            </div>
            <div class="row custom-margin-top">
              <div class="col-md-12">
                <input id="rdoOnlyBetween" type="radio" value="false" v-model="popupData.ShowAnyTime" name="notifcationwindow" />
                <label for="rdoOnlyBetween">{{ $t("message.onlybetween") }}</label>

                <select v-model="popupData.WindowStartTime" :disabled="ShowAnyTime" v-on:change="popupData.WindowEndTime = Math.max(popupData.WindowStartTime, popupData.WindowEndTime)" class="form-control form-control-sm" aria-label="Select Start Time">
                  <option v-for="option in getSelectTimeList()" v-bind:value="option.value" :key="option.value">{{option.text}}</option>
                </select>
                
                {{ $t("message.and") }}
                <select v-model="popupData.WindowEndTime" :disabled="ShowAnyTime" class="form-control form-control-sm" aria-label="Select End Time">
                  <option v-for="option in getSelectTimeList()" v-bind:value="option.value" :key="option.value" :disabled="option.value < popupData.WindowStartTime">{{option.text}}</option>
                </select>
                &nbsp;&nbsp;
                <select v-model="popupData.ZoneID" v-if="timeZones && timeZones.length > 0" class="form-control form-control-m">
                  <option v-for="zone in timeZones" v-bind:value="zone.ID" v-bind:key="zone.ID">{{zone.TimeZone}}</option>
                </select>
              </div>
            </div>
          </fieldset>          
        </form>
      </div>
      <p slot="footer">
        <span class="pull-right">
          <button class="btn btn-primary" @click="saveWindow()" aria-label="Save Notification Window Settings" :disabled="disableEditOrDelete">{{ $t("message.save") }}</button>
          &nbsp;
          <button class="btn btn-cancel" @click="closeModal()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
        </span>
      </p>
    </modal>
    <!-- For verifications, we delete the contact in the event of a code.  On the other hand, if they refresh the page or just close it, we oddly keep it... not sure
        if that is how we want it.-->
    <modal v-show="showModal === 5" @close="closeModal()">
      <h4 class="modal-title" slot="header">{{ $t("message.changeAddress") }}</h4>
      <div slot="body">
        <form @submit.prevent="saveAddress()">
          <span class="row">
            <div class="col-md-6 col-xs-12">
              <label for="address1" class="controlLabel">{{ $t("message.address1") }}</label>
              <br />
              <input id="address1" type="text" class="form-control" v-model="popupData.Address1" ref="modalChangeBillingAddress1" />
            </div>
            <div class="col-md-6 col-xs-12">
              <label for="address2" class="controlLabel">{{ $t("message.address2") }}</label>
              <br />
              <input id="address2" type="text" class="form-control" v-model="popupData.Address2" />
            </div>

          </span>
          <span class="row">
            <div class="col-md-4 col-xs-12">
              <label for="city" class="controlLabel">{{ $t("message.city") }}</label>
              <br />
              <input id="city" type="text" class="form-control form-control-175" v-model="popupData.City" />
            </div>
            <div class="col-md-3 col-xs-12">
              <label for="state" class="controlLabel">{{ $t("message.state") }}</label>
              <br />
              <select id="state" v-model="popupData.State" class="form-control form-control-125">
                <option v-for="st in stateList" v-bind:value="st.StateCode" :key="st.StateCode">{{st.Name}}</option>
              </select>
            </div>
            <div class="col-md-3 col-xs-12">
              <label for="zipcode" class="controlLabel">{{ $t("message.zip") }}</label>
              <br />
              <input id="zipcode" type="text" class="form-control form-control-100" v-model="popupData.Zip" v-on:keypress="isNumber(event)" maxlength="5" />
            </div>
          </span>
        </form>
      </div>
      <p slot="footer">
        <span class="pull-right">
          <button class="btn btn-primary" @click="saveAddress()" aria-label="Save Address" :disabled="disableEditOrDelete">{{ $t("message.save") }}</button>
          &nbsp;
          <button class="btn btn-cancel" @click="closeModal()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
        </span>
      </p>
    </modal>
    <modal v-show="showModal === 6" @close="closeModal()">
      <h4 class="modal-title" slot="header">{{ medicallyFragileSettings.headerText }}</h4>
      <div slot="body">
        <p>{{medicallyFragileSettings.modalConfirmMessage}}</p>
      </div>
      <p slot="footer">
        <span class="pull-right">
          <button class="btn btn-primary" @click="SetMedFragAndSendMessage()" aria-label="Medically Fragile Send Message">{{ medicallyFragileSettings.btnText }}</button>
          &nbsp;
          <button class="btn btn-cancel" @click="closeModal()" aria-label="Cancel">{{ $t("message.cancel") }}</button>
        </span>
      </p>
    </modal>
    <!--End Notification Pop-ups-->
  </div>

</template>

<script>
  import { mixin as focusMixin }  from 'vue-focus';
  import axios from "axios";
  import Modal from '@/components/common/Modal';
  
  export default {
    name: "Notifications",
    components: {
      Modal
    },
    mixins: [ focusMixin ],
    data() {
      return {
        //Contacts
        notificationTypes: [],
        popupData: {},
        popupText: '',
        showModal: 0,
        popupIsCritical: false,
        notificationWindows: [],
        stateList: [],
        address: {},
        timeZones: [],
        isBillingAddressEditable: true,
        addressLoaded: false,
        filteredContactTypes: [],
        contactTypeIdSelectedForCritical: -1,
        verifyCodeInput: '',
        focused: false,
        textMessageDisclaimer: '',
        barcodeDetails: '',
        dailyAlertDetails: '',
        previousDailyAlertAmount: null,
        medicallyFragileSettings: {}
    }
  },
  methods: {
    getImageSrc(msgOptIn, typeId) {
      if (typeId === this.$contactTypes.Email) {
        return "";
      }

      switch(msgOptIn) {
        case this.$OptIns.OptIn:
          return require('@/assets/img/green.png');
          break;
        case this.$OptIns.OptInPending:
          return require('@/assets/img/yellow.png');
          break;
        case this.$OptIns.OptOutPending:
          return require('@/assets/img/red.png');
          break;
        default:
          //Should not be here; fully opted out should not actually return.  But just so this never breaks.
          return "";
          break;
      }
    },
    getImageTitle(msgOptIn) {
      switch (msgOptIn) {
        case this.$OptIns.OptIn:
          return this.translateText("optin");
          break;
        case this.$OptIns.OptInPending:
          return this.translateText("optinpending");
          break;
        case this.$OptIns.OptOutPending:
          return this.translateText("optoutpending");
          break;
        default:
          return "";
          break;
      }
    },
    getMessageType(typeId) {
      switch (typeId) {
        case this.$contactTypes.Email:
          return this.translateText("Email Address");
          break;
        case this.$contactTypes.Text:
        case this.$contactTypes.Voice:
          return this.translateText("Phone Number");
          break;
        case this.$contactTypes.Critical:
          return this.translateText("Phone Number or Email Address");
          break;
      }
    },
    getMessageWindow(startTime, endTime, zoneID) {
      if (startTime === 0 && endTime === 0) {
        return this.translateText("anytime");
      }
        var timeZone = "";
      if (zoneID !== undefined && this.timeZones && this.timeZones.length > 1)
      {
        if (this.timeZones.length > 1)
        {
          for (var i = 0; i < this.timeZones.length; i++)
          {
            if (this.timeZones[i].ID === zoneID)
            {
              timeZone = this.timeZones[i].TimeZone;
              break;
            }
          }
        }
      }
      return this.translateText("onlybetween") + " " + this.$calcTimeString(startTime) + " " + this.translateText("and") + " " + this.$calcTimeString(endTime) + " " + timeZone;
    },
		getTimeZones() {
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/GetTimeZones"
      }).then(result => {
        var response = result.data
        if (response !== '') {
          this.timeZones = response;
        }
      }, error => {
        console.log(error);
      });
    },
    translateText(pageText) {
      if (pageText === undefined) {
        return ""
      }

      var languages = this.$i18n.messages;
      var currentLanguage = this.$i18n.locale;

      // Check if current language is part of our set up
      if (currentLanguage in languages) {
        // Get all the messages for this language
        var currentLanguageMessages = languages[currentLanguage].message;
        if (currentLanguageMessages !== null && (pageText !== "")) {
          var languageText = currentLanguageMessages[pageText.replace(/ /g, "").toLowerCase()];
          return languageText !== undefined ? languageText : pageText;
        }
      }

      return pageText;
    },
    getSelectTimeList() {
      var rtn = [];
      var i;
      for (i = 0; i < 24; i++) {
        if (i == 0) {
          rtn.push({value: 0, text: "12:00 AM"});
        } else if (i < 12) {
          rtn.push({value: i, text: i + ":00 AM"});
        } else if (i === 12) {
          rtn.push({value: i, text: "12:00 PM"});
        } else {
          rtn.push({value: i, text: (i - 12) + ":00 PM"});
        }
      }
        return rtn;
    },
    openModal(data, type) {
        this.showModal = type;
        //Makes a copy, does not assign to the original.
        this.popupData = Object.assign({}, data);
        this.popupText = '';
        this.popupIsCritical = false;

        // Get the Contact Types to display in Add New Modal (will only show up for Critical contacts)
        if (this.filteredContactTypes.length === 0) {
            this.getContactTypes();
        }
                
        switch (type) {
          case this.$modalTypes.Address:
            // Change Billing Address Modal - set focus on Address1 input
            this.$nextTick(() => this.$refs.modalChangeBillingAddress1.focus());            
            break;        
          case this.$modalTypes.Add:
            // Add Contact Modal - set focus on Email/Phone inputs
            this.focusBasedOnContactTypeForAddContactModal(this.popupData.ID);
            break;
        }
    },
    focusBasedOnContactTypeForAddContactModal(contactTypeId) {
      this.$nextTick(() => {
        switch (contactTypeId) {
          case this.$contactTypes.Email:
            this.$refs.modalAddContactEmail.focus();            
            break;       
          default:
            this.$refs.modalAddContactPhone.focus();
            break;
        }       
      });      
    },
    closeModal() {
        this.showModal = this.$modalTypes.None;
    },
    changeActive(id) {
        axios({
            method: "POST",
            data: {
                contactId: id
            },
            url: this.$httpAxiosBaseUrl() + "Notification/UpdateActive"
        }).then(result => {
            var response = result.data;
            if (response.charAt(0) === '+') {
                // '+' is used to indicate success/new contact has been activated                        
                this.showSuccess(response.substring(1));
            } else if (response !== "") {
                this.showError(response);
            }

            this.getCurrentCustomerNotifications();
            this.getBarcodeSettings();
            this.getDailyAlertSettings();
        });
    },
    saveContact() {
        var self = this;
        var contactTypeId = self.popupData.ID;
        this.popupIsCritical = this.contactTypeIdSelectedForCritical !== -1;
        // If contact is critical, get the ContactTypeId from the dropdown
        if (this.popupIsCritical) {
            contactTypeId = this.contactTypeIdSelectedForCritical;
        }

        // Validate Input
        switch (contactTypeId) {
            case this.$contactTypes.Email:
                if (!this.$checkEmail(this.popupText)) {
                    this.showError(this.translateText("entervalidemailaddress"));
                    return;
                }
                break;
            case this.$contactTypes.Critical:
                //Critical can be either Phone OR email
                if(!this.$checkEmail(this.popupText) && !this.$checkPhone(this.popupText)) {
                  this.showError(this.translateText("entervalidphoneoremail"));
                  return;
                }             
                break;
            default:
              if (!this.$checkPhone(this.popupText)) {
                this.showError(this.translateText("entervalidphone"));
                return;
              }
              break;
          }   

        axios({
          method: "POST",
          data: {
            value: this.popupText,
            typeId: contactTypeId,
            isCritical: this.popupIsCritical
          },
          url: this.$httpAxiosBaseUrl() + "Notification/SaveContact"
        }).then(result => {
          var response = result.data;
          
          if (response) {
            this.contactTypeIdSelectedForCritical = -1;

            if (response.ErrorMessage) {
              this.showError(response.ErrorMessage);
              return;
            } else if (response.VerifyCode) {
              // If response received starts with + then we need to display the verify code popup
              var insertedContactId = response.ContactId;
              this.openModal({"ID": insertedContactId}, this.$modalTypes.Verify);
              return;
            } else {
              // If response received starts with '|', and if we get a valid Id back it means that the insert was successful
              // Now we will go ahead and reload all our contacts again so we get the appropriate status for each contact
              this.getCurrentCustomerNotifications();
              this.getBarcodeSettings();
              this.getDailyAlertSettings();
              this.closeModal();
              return;
            }
          }         
        });
    },
    saveWindow() {
      var self = this;
      //If they checked "show any time", this is saved in the db with 0 in both times.
      if (self.popupData.ShowAnyTime === "true") {
        self.popupData.WindowStartTime = 0;
        self.popupData.WindowEndTime = 0;
      }
      axios({
        method: "POST",
        data: {
        "nc": self.popupData
        },
        url: this.$httpAxiosBaseUrl() + "Notification/ChangeNotificationWindow"
      }).then(result => {
        for (var index = 0, len = self.notificationTypes.length; index < len; index++) {
          if(self.notificationTypes[index].ID === self.popupData.ID) {
            self.notificationTypes[index].WindowStartTime = self.popupData.WindowStartTime;
            self.notificationTypes[index].WindowEndTime = self.popupData.WindowEndTime;
            self.notificationTypes[index].ZoneID = self.popupData.ZoneID;
            self.notificationTypes[index].ShowAnyTime = (self.popupData.WindowStartTime === 0 && self.popupData.WindowEndTime === 0);
            break;
          }
        }
        this.closeModal();
      });
    },
    deleteContact() {
      var self = this;

      axios({
        method: "POST",
        data: {
          contactId: self.popupData.ID
        },
        url: this.$httpAxiosBaseUrl() + "Notification/DeleteContact"
      }).then(result => {
        var response = result.data;
        if (response === "") {
          // Contact has been successfully deleted
          this.getCurrentCustomerNotifications();
          this.getBarcodeSettings();
          this.getDailyAlertSettings();
        } else {
          this.showError(response);
          return;
        }
      }, error => {
        console.log(error);
      });

      this.closeModal();
    },
    updateNotice(window) {
      window.DayActive = !window.DayActive;

      axios({
        method: "POST",
        data: {
          dayOptionId: window.ID,
          isChecked: window.DayActive
        },
        url: this.$httpAxiosBaseUrl() + "Notification/UpdateCustomerWindow"
      });
    },
    isNumber (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    verifyCode() {
      axios({
        method: "POST",
        data: {
          contactId: this.popupData.ID,
          enteredCode: this.verifyCodeInput
        },
        url: this.$httpAxiosBaseUrl() + "Notification/VerifyCode"
      }).then(result => {
        var response = result.data;
        if (response === "") {
          // Everything worked, fetch all the latest data
          this.getCurrentCustomerNotifications();
          this.getBarcodeSettings();
          this.getDailyAlertSettings();
          this.closeModal();
          this.showSuccess("Your number is now active.");
        } else {
          this.showError(response);
        }
        this.verifyCodeInput = '';
      }, error => {
        console.log(error);
      });
    },
    sendCode(id) {
      // You can end up here one of two ways. Either certain vendors will automatically add their contacts, but have them pending (so the "Verify" button will show).
      // You can also have failed to verify before, so you get a new code.
      axios({
        method: "POST",
        data: {
          contactId: id
        },
        url: this.$httpAxiosBaseUrl() + "Notification/ResendCode"
      }).then(result => {
        var response = result.data;
        if (response === '') {
          this.openModal({"ID": id}, this.$modalTypes.Verify);
        }
      }, error => {
        console.log(error);
      });
    },
    saveAddress() {
      var self = this;
      if (this.popupData.Address1.length === 0) {
        this.showError(this.translateText("Enter your address in") + " " + this.translateText("Address1"));
        return
      }
      if (this.popupData.City.length === 0) {
        this.showError(this.translateText("Enter a city."));
        return
      }
      if (this.popupData.State.length === 0) {
        this.showError(this.translateText("Select a state."));
        return;
      }
      if (this.popupData.Zip.length !== 5) {
        this.showError(this.translateText("Enter a zip code."));
        return;
      }

      axios({
        method: "POST",
        data: {
          address: this.popupData
        },
        url: this.$httpAxiosBaseUrl() + "Notification/SaveCustomerAddress"
      }).then(result => {
        var response = result.data;
        if (response.match("^Error")) {
          this.showError(response);
          return;
        }

        // Set the values to what they put in
        this.address = Object.assign({}, this.popupData);
        this.closeModal();
      });
    },
    loadNotificationContactData() {

      // Get States
      this.stateList = this.$store.getters.getStateList;
      if (this.stateList === undefined) {
        axios({
          method: "GET",
          url: this.$httpAxiosBaseUrl() + "Notification/GetStateList"
        }).then(result => {
          var response = result.data
          if (response !== '') {
            this.stateList = response;
            this.$store.commit('setStateList', response);
          }
        }, error => {
          console.log(error);
        });
      }

      // Get Current Notification Contacts
      this.getCurrentCustomerNotifications();

      // Get Customer Windows
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/GetCustomerWindows?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data;
        if (response !== '') {
          this.notificationWindows = response;
        }
      }, error => {
        console.log(error)
      });

      // Get Customer Address
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/GetCustomerAddress?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data
        if (response !== '') {
          this.address = response.Address;
          this.isBillingAddressEditable = response.IsBillingAddressEditable;
          this.addressLoaded = true;
        }
      }, error => {
        console.log(error);
      });
    },
    getCurrentCustomerNotifications() {
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/CurrentNotifications?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data
        if (response !== '') {
          this.notificationTypes = response;
        }
      }, error => {
        console.log(error);
      });
    },
    getBarcodeSettings() {
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/GetBarcodeSettings?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data;
        if (response.Message !== '') {
          this.barcodeDetails = response;
        } else {
          this.barcodeDetails = '';
        }
      }, error => {
        console.log(error);
      });
    },
    getDailyAlertSettings()
    {
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/GetDailyAlertSettings?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data;

        if (response !== '') {
          this.dailyAlertDetails = response;
          this.previousDailyAlertAmount = response.Amount;
        } else {
          this.dailyAlertDetails = '';
          this.previousDailyAlertAmount = null;
        }
      }, error => {
        console.log(error);
      });
    },
    saveDailyUsage(isSave) {
        // Same method is used by 'Save' and 'Unenroll' buttons
        // The isSave allows us to know if they are saving the amount or unenrolling

        // Save: Validate Input if we are saving/saving an amount...
        if (isSave) {
            // If the amount is not null, verify that it is a valid number
            var inputAmount = this.dailyAlertDetails.Amount;
            if (inputAmount != null) {
              if(isNaN(inputAmount)){
                this.showError("Please ensure the amount is a valid amount.");
                return;
              }
            if (inputAmount < 0) {
                this.showError("Please ensure that the amount is a positive numeric value.");
                return;
            }    
          }             
        }            

        // Save Autopay amount
        axios({
            method: "POST",
            url: this.$httpAxiosBaseUrl() + "Notification/SaveDailyAlertAmount?date=" + new Date().getTime(),
            data: {
                amount: isSave ? this.dailyAlertDetails.Amount : null,
                previousAmount: this.previousDailyAlertAmount
            } 
        }).then(result => {
          var response = result.data;
          if (response.Message !== '') {            
            // Display the message returned from the BL for the customer...
            this.showSuccess(response.Message);
            // After saving, set the previous amount to what was just saved.
            // Or set it to null if this wasn't a save but an unenrollment.  
            this.previousDailyAlertAmount = isSave ? response.Amount : null;
            // Now update the internal object with the new amount(Formatted), or null if this was an unenrollment.
            this.dailyAlertDetails.Amount = isSave ? response.Amount : null;                  
          }
        }, error => {
            console.log(error);
        });
    },
    sendPaymentBarcode() {
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/SendPaymentBarcode?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data;
        if (response.Message !== '') {
          // Based on IsSuccess we will display Success/Error toast.
          if (response.IsSuccess) {
            this.showSuccess(response.Message);
          } else {
            this.showError(response.Message);
          }
        }
      }, error => {
        console.log(error);
      });
    },
    showError(message) {
      this.$toasted.global.error(message);
      this.$announcer.set(message);
    },
    showSuccess(message) {
      this.$toasted.global.success(message);
      this.$announcer.set(message);
    },
    getContactTypes() {
      this.filteredContactTypes.push({ ID: -1, Name: 'Select...' });
      this.notificationTypes.forEach(element => {
        if (element.ID !== this.$contactTypes.Critical) {
          this.filteredContactTypes.push({ ID: element.ID, Name: element.Name });
        }
      });
    },
    GetMedFragSettings() {
      axios({
        method: "GET",
        url: this.$httpAxiosBaseUrl() + "Notification/GetMedFragSettings?date=" + new Date().getTime()
      }).then(result => {
        var response = result.data;
        if (response !== '') {
          this.medicallyFragileSettings = response;
        }
      }, error => {
        console.log(error);
      });
    },
    SetMedFragAndSendMessage() {
      this.closeModal();
      axios({
        method: "POST",
        url: this.$httpAxiosBaseUrl() + "Notification/SetMedFragAndSendMessage"
      }).then(result => {
        var response = result.data;
        if (response.Message !== '') {
          // Based on IsSuccess we will display Success/Error toast.
          if (response.IsSuccess) {
            this.GetMedFragSettings();
            this.showSuccess(response.Message);
          } else {
            this.showError(response.Message);
          }
        }
      }, error => {
        console.log(error);
      });
    }
  },
  computed: {
    displayBillingAddress() {
      return this.address.AddressID !== 0 && this.addressLoaded;
    },
    lowBalanceDaysDescriptionText() {
      return this.$store.getters.getLowBalanceDaysDescriptionText;
    },
    disableEditOrDelete() {
      return this.$store.getters.getIsCSRReadOnly;
    }
  },
  mounted() {
    this.textMessageDisclaimer = this.$store.getters.getTextMessageDisclaimer;
    this.getTimeZones();
    this.loadNotificationContactData();
    this.getBarcodeSettings();
    this.GetMedFragSettings();
    this.getDailyAlertSettings();
  }
}

</script>

<style scoped>
  .list-group {
    margin-bottom: 8px;
  }

  .list-group-item {
    padding: 0 0;
  }

  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .form-control-sm {
    width: 95px !important;
  }

  .form-control-m {
    width: 185px !important;
  }

  .contact-div .btn, .btn-change {
    min-width: 63px;
  }

  .lowbalance-title {
    margin-top: 0;
  }

  .div-btn-delete {
    float: right;
  }

  .pad5 {
    padding: 5px;
  }

  .pad-top-10 {
    padding-top: 10px;
  }

  .line25 {
    line-height: 2.5;
  }

    .line25 div {
      line-height: normal;
      margin-bottom: 10px;
    }

  .padnotif {
    padding-right: 21px;
  }

  .form-control {
    width: 100%;
  }

  .contact-div {
    width: 49%;
    margin-right: 1%;
    min-height: 70px;
  }

  .divLowBalanceNotificationDays {
    margin-right: 5px;
  }

    .divLowBalanceNotificationDays button {
      min-width: 36px;
      min-height: 36px;
    }

  @media only screen and (max-width: 990px) {
    .contact-div {
      width: 100%;
      margin-right: 0;
    }
  }

  #divTextMessageDisclaimer .disclaimer-text a {
    font-weight: normal;
  }

  /*-- Send Barcode --*/
  .margin-top-25 {
    margin-top: 25px;
  }

  .margin-top-15 {
    margin-top: 15px;
  }

  .margin-bottom-25 {
    margin-bottom: 25px;
  }

  .dailyalert-amt {
    border-radius: 0;
    height: 35px;
    width: 100px;
}

  #barcodeMessage {
    line-height: 16px;
  }

  #dailyAlertMessage {
    line-height: 16px;
  }

  #btnSendBarcode {
    background: #3276b1 !important;    
    border-color: #3276b1 !important;
  }

    #btnSendBarcode:hover, #btnSendBarcode:focus {
      color: #ffffff !important;
    }

 @media only screen and (max-width: 400px) {
    #divSendBarcode #btnSendBarcode {
      width: 100%;
      padding-top: 6px;
    }
  }
</style>